import { render, staticRenderFns } from "./SimilarityIndicator.vue?vue&type=template&id=5bbbfa2a"
import script from "./SimilarityIndicator.vue?vue&type=script&lang=js"
export * from "./SimilarityIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports